module.exports = __webpack_public_path__ + "img/hontai_WaterBlue.172a21cb.png";